import { useResendVirtualInviteMutation } from "../../../../../../../api/mutations/useResendVirtualInviteMutation";
import { uiNotification } from "../../../../../../../services/UINotificationService";

export const useResendInvite = () => {
  const { mutateAsync, isLoading } = useResendVirtualInviteMutation({
    onSuccess: () => {
      uiNotification.success("Link resent successfully");
    },
    onError: () => {
      uiNotification.error("Failed to resend invite. Try again later.");
    },
  });

  return {
    initiate: (appointmentId) => mutateAsync({ appointmentId }),
    isLoading,
  };
};
